import Icon from '../components/Icon.vue'

Icon.register({
  stream: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M16 128H432C440.8 128 448 120.8 448 112V48C448 39.2 440.8 32 432 32H16C7.2 32 0 39.2 0 48V112C0 120.8 7.2 128 16 128zM496 208H80C71.2 208 64 215.2 64 224V288C64 296.8 71.2 304 80 304H496C504.8 304 512 296.8 512 288V224C512 215.2 504.8 208 496 208zM432 384H16C7.2 384 0 391.2 0 400V464C0 472.8 7.2 480 16 480H432C440.8 480 448 472.8 448 464V400C448 391.2 440.8 384 432 384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/stream.js
// module id = efLT
// module chunks = 144